import React from 'react';
import { FaArrowCircleDown, FaCheckCircle, FaQuestionCircle, FaFilter, FaLock, FaStar, FaRegStar, FaUnlock } from 'react-icons/fa';


export const CheckingTicket = ({ checkingId, checkingName }) => {
  return (
    <span title={checkingName}>
      {checkingId === 13 && (
        <FaQuestionCircle className="text-danger" title={checkingName} size={15} />
      )}
      {checkingId === 14 && (
        <FaArrowCircleDown className="text-info" title={checkingName} size={15} />
      )}
      {checkingId === 15 && (
        <FaCheckCircle className="text-success" title={checkingName} size={15} />
      )}
    </span>
  );
};

export const LockingTicket = ({ isLocking }) => {
  return (
    <span>
      {!isLocking && (
        <FaUnlock className="text-success mt-1" title="Đơn hàng đang mở" size={15} />
      )}
      {isLocking && (
        <FaLock className="text-danger mt-1" title="Đơn hàng đang bị khóa" size={15} />
      )}
    </span>

  );
};
export const StarRating = ({ rating }) => {
  return (
    <span>
      {[...Array(5)].map((_, index) =>
        index < rating ? (
          <FaStar key={index} color="gold" />
        ) : (
          <FaRegStar key={index} color="gray" />
        )
      )}
    </span>

  );
};

export const FeedbackChecking = ({ commentId }) => {
  return (    
    <span>
      {commentId && (
        <span title="Đã đánh giá"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check" viewBox="0 0 16 16">
          <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
        </svg></span>
      )}
      {!commentId && (
        <span title="Chưa đánh giá"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-circle" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        </svg></span>
      )}
    </span>
  );
};


export const NextIcon = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
      </svg>
    </span>
  );
};

export const EyeIcon = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye" viewBox="0 0 16 16">
        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
      </svg>
    </span>
  );
};
export const ClockIcon = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-alarm" viewBox="0 0 16 16">
        <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9z" />
        <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1zm1.038 3.018a6 6 0 0 1 .924 0 6 6 0 1 1-.924 0M0 3.5c0 .753.333 1.429.86 1.887A8.04 8.04 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5M13.5 1c-.753 0-1.429.333-1.887.86a8.04 8.04 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1" />
      </svg>
    </span>
  );
};
export const BellIcon = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bell-fill" viewBox="0 0 16 16">
        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901" />
      </svg>
    </span>
  );
};
export const PersonIcon = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-vcard" viewBox="0 0 16 16">
        <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5" />
        <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z" />
      </svg>
    </span>
  );
};
export const WarningIcon = () => {
  return (
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
      </svg>
    </span>
  );
};
export const MedalIcon = ({ rank }) => {

  function getSmallMedalNumber(value) {
    if (value >= 625) {
      return 0;
    }
    if (value <= 5) {
      return 0;
    } else if (value <= 25) {
      return value % 5;
    } else if (value < 125) {
      var floor = Math.floor(value / 25);
      var extra = value - floor * 25;
      return Math.floor(extra / 5);
    } else if (value < 625) {
      var floor = Math.floor(value / 125);
      var extra = value - floor * 125;
      return Math.floor(value / 25);
    } else {
      return 0;
    }
  }
  function getMedalNumber(value) {
    if (value >= 625) {
      return 5;
    }
    if (value < 1) {
      return 0;
    } else if (value <= 5) {
      return value;
    } else if (value <= 25) {
      return Math.floor(value / 5);
    } else if (value <125) {
      return Math.floor(value / 25);
    } else if (value < 625) {
      return Math.floor(value / 125);
    } else {
      return 0;
    }
  }

  return (
    <span className="d-flex">
    <span className="d-none" data-rank={rank}>
      {[...Array(getMedalNumber(rank))].map((_, index) => {
        if (rank < 1) {
          return <span key={index}>Chưa có thành tích</span>;
        } else if (rank <= 5) {
          return <MedalBronze key={index} />;
        } else if (rank <= 25) {
          return <MedalSilver key={index} />;
        } else if (rank <= 125) {
          return <MedalGold key={index} />;
        } else if (rank > 125) {
          return <MedalGold key={index} />;
        }
      })}
    </span>
      <span className="medal-line" title={`rank: ${rank}` }>
        {[...Array(getMedalNumber(rank))].map((_, index) => {
          if (rank < 1) {
            return <span key={index}>Chưa có thành tích</span>;
          } else if (rank <= 5) {
            return <span title="Huy chương Đồng" className="medal medal-bronze"></span>;
          } else if (rank <= 25) {
            return <span title="Huy chương Bạc" className="medal medal-silver"></span>;
          } else if (rank <= 125) {
            return <span title="Huy chương Vàng" className="medal medal-gold"></span>;
          } else if (rank > 125) {
            return <span title="Huy chương Kim Cương" className="medal medal-dimond"></span>;
          }
        })}
      </span>
      <span className="medal-line" title={`rank: ${rank}`}>
        {[...Array(getSmallMedalNumber(rank))].map((_, index) => {
          if (rank < 1) {
            return <span key={index}></span>;
          } else if (rank <= 25) {
            return <span title="Huy chương Đồng" className="medal medal-bronze"></span>;
          } else if (rank <= 125) {
            return <span title="Huy chương Bạc" className="medal medal-silver"></span>;
          } else if (rank <= 625) {
            return <span title="Huy chương Vàng" className="medal medal-gold"></span>;
          }
        })}
      </span>
    </span>
  );
};
export const MedalGold = () => {
  return (
    <span title="Huy chương Vàng">
      <svg width="60px" height="60px" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <style>{`
        .st0 { fill: #E24255; }
        .st1 { fill: #FFC54D; }
        .st2 { fill: #E8B04B; }
        .st3 { fill: #FFFFFF; }
      `}</style>
        <g>
          <polygon className="st0" points="79.7,45.6 60,55.5 40.3,45.6 15.9,94.3 31.1,92.8 38.9,105.9 60,63.9 81.1,105.9 88.9,92.8    104.1,94.3  " />
          <circle className="st1" cx="60" cy="46.4" r="32.2" />
          <circle className="st2" cx="60" cy="46.4" r="25.3" />
          <path className="st3" d="M61.2,31.2l4.2,8.4c0.2,0.4,0.6,0.7,1,0.8l9.3,1.4c1.1,0.2,1.6,1.5,0.8,2.3l-6.7,6.6c-0.3,0.3-0.5,0.8-0.4,1.2   l1.6,9.3c0.2,1.1-1,2-2,1.4l-8.3-4.4c-0.4-0.2-0.9-0.2-1.3,0L51,62.6c-1,0.5-2.2-0.3-2-1.4l1.6-9.3c0.1-0.4-0.1-0.9-0.4-1.2   l-6.7-6.6c-0.8-0.8-0.4-2.2,0.8-2.3l9.3-1.4c0.4-0.1,0.8-0.3,1-0.8l4.2-8.4C59.3,30.2,60.7,30.2,61.2,31.2z" />

        </g>
      </svg>
    </span>
  );
};

export const MedalSilver = () => {
  return (
    <span title="Huy chương Bạc">
      <svg width="60px" height="60px" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <style>{`
	      .st0b{fill:#FFBF4B;}
	      .st1b{fill:#EDEDED;}
	      .st2b{fill:#BCBCBC;}
	      .st3b{fill:#FFFFFF;}
      `}</style>
        <g>
          <polygon className="st0b" points="79.7,45.6 60,55.5 40.3,45.6 15.9,94.3 31.1,92.8 38.9,105.9 60,63.9 81.1,105.9 88.9,92.8    104.1,94.3  " />
          <circle className="st1b" cx="60" cy="46.4" r="32.2" />
          <circle className="st2b" cx="60" cy="46.4" r="25.3" />
          <path className="st3b" d="M61.2,31.2l4.2,8.4c0.2,0.4,0.6,0.7,1,0.8l9.3,1.4c1.1,0.2,1.6,1.5,0.8,2.3l-6.7,6.6c-0.3,0.3-0.5,0.8-0.4,1.2   l1.6,9.3c0.2,1.1-1,2-2,1.4l-8.3-4.4c-0.4-0.2-0.9-0.2-1.3,0L51,62.6c-1,0.5-2.2-0.3-2-1.4l1.6-9.3c0.1-0.4-0.1-0.9-0.4-1.2   l-6.7-6.6c-0.8-0.8-0.4-2.2,0.8-2.3l9.3-1.4c0.4-0.1,0.8-0.3,1-0.8l4.2-8.4C59.3,30.2,60.7,30.2,61.2,31.2z" />

        </g>
      </svg>
    </span>
  );
};

export const MedalBronze = () => {
  return (
    <span title="Huy chương Đồng">
      <svg width="60px" height="60px" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" >
        <style>{`
        .st0c { fill: #C4C4C4; }
        .st1c { fill: #E5B97F; }
        .st2c { fill: #C19A6B; }
        .st3c { fill: #FFFFFF; }
      `}</style>
        <g>
          <polygon
            className="st0c"
            points="79.7,45.6 60,55.5 40.3,45.6 15.9,94.3 31.1,92.8 38.9,105.9 60,63.9 81.1,105.9 88.9,92.8 104.1,94.3"
          />
          <circle className="st1c" cx="60" cy="46.4" r="32.2" />
          <circle className="st2c" cx="60" cy="46.4" r="25.3" />
          <path
            className="st3c"
            d="M61.2,31.2l4.2,8.4c0.2,0.4,0.6,0.7,1,0.8l9.3,1.4c1.1,0.2,1.6,1.5,0.8,2.3l-6.7,6.6c-0.3,0.3-0.5,0.8-0.4,1.2
          l1.6,9.3c0.2,1.1-1,2-2,1.4l-8.3-4.4c-0.4-0.2-0.9-0.2-1.3,0L51,62.6c-1,0.5-2.2-0.3-2-1.4l1.6-9.3c0.1-0.4-0.1-0.9-0.4-1.2
          l-6.7-6.6c-0.8-0.8-0.4-2.2,0.8-2.3l9.3-1.4c0.4-0.1,0.8-0.3,1-0.8l4.2-8.4C59.3,30.2,60.7,30.2,61.2,31.2z"
          />
        </g>
      </svg>
    </span>
  );
};